"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeBigInt = exports.serializeBigInt = void 0;
const serializeBigInt = (v) => v.toString();
exports.serializeBigInt = serializeBigInt;
const deserializeBigInt = (s) => {
    try {
        return BigInt(s);
    }
    catch (e) {
        throw new Error(`Invalid input for bigint: '${s}'`);
    }
};
exports.deserializeBigInt = deserializeBigInt;
//# sourceMappingURL=bigint.js.map